import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import PhotoGallery from '@/components/ui/PhotoGallery/PhotoGallery';
import SearchHeader from '@/components/ui/SearchHeader/SearchHeader';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { IImage } from '@/services/types/search/rentals/id';

import { ActionBar } from './ActionBar';

type THeroProps = {
  name: string;
  location: string;
  images: IImage[];
  scrollToSearchFilter?: () => void;
};

export const Hero = ({ name, location, images, scrollToSearchFilter }: THeroProps) => {
  const { isMobile } = useBreakpoint();

  if (!images || !images.length) return null;
  return (
    <section className="pb-4 md:pb-8">
      <MaxWidth className="relative mx-auto text-center">
        <div className="max-w-md mx-auto text-center">
          {isMobile ? (
            <Heading
              variant={EHeadingStyleVariant.H2}
              className="mx-auto font-normal leading-[100%]"
              component="h1">
              {name}
            </Heading>
          ) : (
            <Heading
              variant={EHeadingStyleVariant.H1}
              className="mx-auto font-normal"
              component="h1">
              {name}
            </Heading>
          )}
        </div>
        <Text variant={ETextStyleVariant.LargeRegular} className="my-2">
          <FormattedMessage defaultMessage={`in {location}`} id="Xq06/i" values={{ location }} />
        </Text>

        <div className="flex justify-center pt-4 pb-8">
          <SearchHeader variant="enhanced" scrollToSearchFilter={scrollToSearchFilter} />
        </div>

        <div className="relative overflow-hidden rounded-lg h-80 md:h-120">
          <PhotoGallery images={images.slice(0, 4)} />
          <ActionBar photoCount={images.length} />
        </div>
      </MaxWidth>
    </section>
  );
};
